export enum FactionType {
  Emperor = "Emperor",
  Guild = "Guild",
  BeneGesserit = "BeneGesserit",
  Fremen = "Fremen",
}
